exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-checkbox.mobile.disabled input:checked ~ span.value[data-v-127f3eb9] {\n  border: 1px solid var(--color11);\n  background-color: var(--color11);\n}\n.custom-checkbox.mobile.disabled input:checked ~ span.value[data-v-127f3eb9]:before {\n  margin: 5px 0 0 5px;\n}\n", ""]);

// exports
